import React from 'react';
import {
  Box,
  // Container,
  Typography,
  Grid,
  Card,
  CardContent,
  styled
} from '@mui/material';
// import {
//   Computer,
//   Speed,
//   People,
//   Security,
//   Support
// } from '@mui/icons-material';
import { CustomLabelMediumBold, CustomLabelRegularLargeMedium, CustomLabelXSmallBold } from '../../common/CustomLabel';
import BUG_FIX from '../../../assets/services/Bug Fixes & Issue Resolution.png';
import PER_MON from '../../../assets/services/Performance Monitoring & Optimization.png';
import MINOR_UPDATE from '../../../assets/services/Minor Updates & Enhancements.png';
import SECURITY from '../../../assets/services/Security Monitoring & Patching.png';
import TECHNICAL from '../../../assets/services/Technical Support.png';
// import { grey } from '@mui/material/colors';

// Styled components
const StyledCard = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'transform 0.3s ease',

  '&:hover': {
    transform: 'translateY(-5px)',
    '& .MuiCardContent-root': {
            '& .benefit-icon': {
                filter: 'grayscale(0%)',
            },
        },
  }
}));

const IconWrapper = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(2),  
  '& .MuiSvgIcon-root': {
    fontSize: '2.5rem',
    color: theme.palette.primary.main,
  },
  filter: 'grayscale(100%)',
  transition: 'filter 0.3s ease',
}));

const MaintenanceOffer = () => {

  const services = [
    {
      icon: <img src={BUG_FIX} alt="Frontend Development" style={{ width: '80px', height: '80px' }} />,
      title: "Bug Fixes and Issue Resolution",
      description: "Even well-tested apps can face unexpected issues after launch. We quickly find and fix bugs to keep your users happy."
    },
    {
      icon: <img src={PER_MON} alt="Frontend Development" style={{ width: '80px', height: '80px' }} />,
      title: "Performance Monitoring and Optimization",
      description: "We track how your app or website performs and make improvements to boost speed, efficiency, and responsiveness."
    },
    {
      icon: <img src={MINOR_UPDATE} alt="Frontend Development" style={{ width: '80px', height: '80px' }} />,
      title: "Minor Updates and Enhancements",
      description: "We handle small updates, feature tweaks, and UX improvements based on user feedback during the maintenance period."
    },
    {
      icon: <img src={SECURITY} alt="Frontend Development" style={{ width: '80px', height: '80px' }} />,
      title: "Security Monitoring and Patching",
      description: "We regularly check for security risks and apply updates to keep your software secure and fully protected."
    },
    {
      icon: <img src={TECHNICAL} alt="Frontend Development" style={{ width: '80px', height: '80px' }} />,
      title: "Technical Support",
      description: "Our experts provide fast technical support, answering your questions and solving any issues as they come up."
    }
  ];

  return (
    <>
    <Grid sx={{ py: 8, bgcolor: 'background.default', padding: {xs: "20px", md: "40px 80px"} }}>
        <Grid item xs={12} display={"flex"} justifyContent={"center"}>
          <CustomLabelMediumBold textAlign={"center"} text="OSTRYX Offers 3 Months of Complimentary Maintenance on Full Project Development Services " color="#5E17EB" />
        </Grid>      
        <Grid item xs={12} sx={{marginTop : "10px"}}>
          <CustomLabelRegularLargeMedium textAlign ={{xs : "left" , md : "center"}} lineHeight={"1.5"} text="At OSTRYX, we know that launching a project is just the start of the journey. That’s why our Full Project Development Services include 3 months of free maintenance and support. We help ensure your web or mobile app stays secure, efficient, and fully optimized for growth. With ongoing technical care, your product is always ready to scale and perform at its best." color="#1A1A1A" />
        </Grid>
        <Grid item xs={12} sx={{marginTop : "40px"}}>
          <CustomLabelRegularLargeMedium text="Here’s what’s included in our post-launch Software Development Services:" color="#1A1A1A" />
        </Grid>

      <Grid container spacing={4} justifyContent="center" sx={{marginTop : "20px"}}>
        {services.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <StyledCard sx={{ borderRadius: 10, border: "1px solid rgb(220, 220, 220)" }}>
              <CardContent>
                <IconWrapper className="benefit-icon">
                  {service.icon}
                </IconWrapper>
                <CustomLabelXSmallBold fontSize={"18px"} textAlign={"left"} color={"#5E17EB"} fontWeight={"700"} text={service.title} />
                  
                <Typography
                  variant="body1"
                  color="text.secondary"
                  sx={{
                    marginTop : "10px"
                  }}
                >
                  {service.description}
                </Typography>
              </CardContent>
            </StyledCard>
          </Grid>
        ))}
    </Grid>
    </Grid>
    </>
  );
};

export default MaintenanceOffer;
